import React from "react";
import { ARTICLE_SECTIONS } from "./sections";

/**
 * "In this article" navigation.
 *
 * Desktop (lg+): sticky rail - Figma 236.09px wide, links 217.58px with
 * 21.46px of top padding.
 * Below lg: the rail would eat the whole viewport width, so the same links
 * render as a horizontally scrollable chip row above the article body.
 */
const ArticleSidebar = ({ activeSection, onSelect }) => {
  return (
    <>
      {/* Mobile / tablet */}
      <div className="lg:hidden">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#0A0D1666] font-jakarta">
          In This Article
        </p>

        <div className="-mx-6 md:-mx-12 mt-3 overflow-x-auto px-6 md:px-12 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <div className="flex w-max gap-2 pb-1">
            {ARTICLE_SECTIONS.map((section) => {
              const isActive = activeSection === section.id;

              return (
                <button
                  key={section.id}
                  type="button"
                  onClick={() => onSelect(section.id)}
                  aria-current={isActive ? "true" : undefined}
                  className={`shrink-0 rounded-full border px-4 py-2 font-jakarta text-[13px] leading-[20px] transition-colors duration-200 cursor-pointer ${
                    isActive
                      ? "border-[#3AB1F6] bg-[#EBF7FE] font-semibold text-[#3AB1F6]"
                      : "border-[#E6ECF5] bg-white font-normal text-[#0A0D1699] hover:text-[#0A0D16]"
                  }`}
                >
                  {section.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Desktop */}
      <aside className="hidden lg:block w-[236.09px] shrink-0 border-l-[1.07px] border-[#E6ECF5] pl-[18.51px]">
        <div className="sticky top-[85.85px] max-h-[calc(100vh-120px)] overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#0A0D1666] font-jakarta">
            In This Article
          </p>

          <nav className="flex flex-col">
            {ARTICLE_SECTIONS.map((section) => {
              const isActive = activeSection === section.id;

              return (
                <button
                  key={section.id}
                  type="button"
                  onClick={() => onSelect(section.id)}
                  aria-current={isActive ? "true" : undefined}
                  className={`w-[217.58px] pt-[21.46px] text-left font-jakarta text-[14.49px] leading-[21.73px] tracking-[0px] transition-colors duration-200 cursor-pointer ${
                    isActive
                      ? "font-semibold text-[#3AB1F6]"
                      : "font-normal text-[#0A0D1699] hover:text-[#0A0D16]"
                  }`}
                >
                  {section.label}
                </button>
              );
            })}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default ArticleSidebar;
